import { IconName } from "PFTheme/graphics/icons";
import { Color } from "PFTypes";
import { DataDogProps } from "PFTypes/datadog";

export enum TabsVariant {
  Horizontal = "horizontal",
  Vertical = "vertical"
}

export enum TabVariant {
  Default = "default",
  Danger = "danger"
}

export type Tab<TabType> = {
  id: TabType;
  title: string;
  subtitle?: string;
  href?: string;
  count?: number;
  icon?: IconName;
  iconColor?: Color;
  rightIcon?: IconName;
  rightIconColor?: Color;
  spread?: boolean;
  variant?: TabVariant;
  disabled?: boolean;
  hidden?: boolean;
  ariaLabel?: string;
} & DataDogProps;
